import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { feathersCreateData } from '../../services';
import ValidatePayRoleComponent from './ValidatePayRoleComponent';
import { useSelector } from 'react-redux';
import client from '../../services/feathers';
import { Box, LinearProgress, Typography } from '@material-ui/core';
// import { useNavigate } from 'react-router-dom';

const ValidatePayRoleContainer = ({ handleLogOut, setLoading, handleOpenSnack }) => {
  const user = useSelector((state) => state.user);
  const user2 = useSelector((state) => state.authentication.user);
  const consolidates = useSelector((state) => state.consolidates);
  // console.log(consolidates);

  const [dataPayrollTray, setDataPayrolltray] = useState({});
  const [dataPayrolls, setDataPayrolls] = useState([]);
  const [dataValidators, setDataValidators] = useState([]);
  const [accountSelected, setAccountSelected] = useState({});
  const [processPercent, setProcessPercent] = useState(0);
  // const navigate = useNavigate();

  const getInitialData = async () => {
    try {
      feathersCreateData('payrolls-control', { service: 'GET_DATA_VALIDATE' })()
        .then(res => {
          const { error } = res
          // console.log("🚀 ~ getInitialData ~ res:", res)
          if (error) {
            // handleOpenSnack(res.message, 'error');
            // history.push('/home')
          } else {
            const { payrollTray, rols, payrollValidate } = res.data
            const { cuentas } = consolidates
            const accSel = cuentas.find(c => c.PRODUCTBANKID === payrollTray.account)
            setDataPayrolltray(payrollTray)
            setDataPayrolls(rols)
            setDataValidators(payrollValidate)
            setAccountSelected(accSel)
            handleOpenSnack(res.message, 'success');
          }
          setLoading(false);
        }).catch(err => {
          // console.log("🚀 ~ getInitialData ~ err:", err)
          setLoading(false);
        })
    } catch (e) {
      console.log(e);
    }
  };
  ValidatePayRoleContainer.propTypes = {
    handleLogOut: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
  };

  useEffect(() => {
    getInitialData();
    socketActivity()
    // eslint-disable-next-line
  }, []);

  const socketActivity = () => {
    client.service('activity-indicator').on('patched', activity => {
      // console.log("🚀 ~ client.service ~ activity:", activity, user)
      const { company: companyActivity, process, percent, state: stateActivity } = activity
      if (companyActivity === user2.company && process === 'PAYROLL_CREATE') {
        setProcessPercent(percent)
        // console.log(stateActivity, process)
        if (stateActivity === 2) {
          getInitialData()
        }
      }
    })
  }



  return (
    (processPercent > 0 && processPercent < 100) ?
      <Box padding={2} margin={2} borderRadius={10} style={{ backgroundColor: '#fff' }}>
        <Box >
          <p><b>Estimado socio</b></p>
          <p>
            Actualmente la nómina está en proceso de validación.
            Esta ventana se actualizará automáticamente.
          </p>
        </Box>
        <Box display="flex" alignItems="center">
          <Box width="100%" mr={1}>
            <LinearProgress variant="determinate" value={processPercent} />
          </Box>
          <Box minWidth={35}>
            <Typography variant="body2" color="textSecondary">{`${Math.round(
              processPercent,
            )}%`}</Typography>
          </Box>
        </Box>
      </Box>
      :
      <ValidatePayRoleComponent
        dataPayrollTray={dataPayrollTray}
        handleLogOut={handleLogOut}
        handleOpenSnack={handleOpenSnack}
        accountSelected={accountSelected}
        dataPayrolls={dataPayrolls}
        dataValidators={dataValidators}
        user={user2}
      />
  );
};
ValidatePayRoleContainer.propTypes = {
  handleLogOut: PropTypes.func.isRequired,
};
export default ValidatePayRoleContainer;
